<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container w-min-800">
          <div class="modal-header">
            <slot name="header">
              New Site
            </slot>
          </div>
          <div class="modal-body">
            <slot name="body">
              <div class="row">
                <div class="col-12">
                  <h3>Site Name</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="name">Name:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    name="name"
                    ref="site_name"
                    placeholder="name"
                    v-model="name"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Site Address</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address1">Address 1:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address1"
                    ref="site_address1"
                    name="address1"
                    placeholder=""
                    v-model="address_line_1"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address2">Address 2:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address2"
                    ref="site_address2"
                    name="address2"
                    placeholder=""
                    v-model="address_line_2"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="address3">Address 3:</label>
                </div>
                <div class="col-6">
                  <input
                    type="text"
                    class="form-control"
                    id="address3"
                    ref="site_address3"
                    name="address3"
                    placeholder=""
                    v-model="address_line_3"
                  />
                </div>
              </div>
              <div class="row">
                <div class=" col-2">
                  <label for="city">City:</label>
                </div>
                <div class="col-4">
                  <input
                    type="text"
                    class="form-control"
                    id="city"
                    ref="site_city"
                    name="city"
                    placeholder="city"
                    v-model="address_city"
                  />
                </div>
                <div class=" col-1">
                  <label for="state">State:</label>
                </div>
                <div class="col-1 no-padding">
                  <input
                    type="text"
                    class="form-control"
                    id="state"
                    ref="site_state"
                    name="state"
                    placeholder="state"
                    v-model="address_state"
                  />
                </div>
                <div class=" col-2">
                  <label for="postcode">Postcode:</label>
                </div>
                <div class="col-1 no-padding">
                  <input
                    type="text"
                    class="form-control"
                    id="postcode"
                    ref="site_postcode"
                    name="postcode"
                    placeholder="0000"
                    v-model="address_postcode"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <h3>Other Information</h3>
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="contact">Contact:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="contact"
                    ref="site_contact"
                    name="contact"
                    placeholder="contact"
                    v-model="contact"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="phone">Phone:</label>
                </div>
                <div class="col-9">
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    ref="site_phone"
                    name="phone"
                    placeholder="phone"
                    v-model="phone"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-2">
                  <label for="notes">Notes:</label>
                </div>
                <div class="col-9">
                  <textarea
                    rows="4"
                    class="form-control"
                    id="notes"
                    ref="site_notes"
                    name="notes"
                    placeholder="notes"
                    v-model="notes"
                  />
                </div>
              </div>
            </slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="btn btn-plt" @click="_save">
                Save &amp; Close
              </button>
              <button class="btn btn-plt" @click="$emit('close')">
                Cancel
              </button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "NewSiteModal",
  props: {
    customer_id: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    name: "",
    address_line_1: "",
    address_line_2: "",
    address_line_3: "",
    address_city: "",
    address_state: "",
    address_postcode: "",
    contact: "",
    phone: "",
    notes: "",
  }),
  computed: {
    ...mapState("customers", ["customers"]),
  },
  mounted: function() {
    this.$nextTick(function() {
      this._reload();
    });
  },
  watch: {
    customer_id() {
      this._reload();
    },
  },
  methods: {
    ...mapActions("sites", ["apiCreateSite"]),
    _save() {
      if (!this.$refs.site_name.value) {
        alert("please enter a name");
        return;
      }
      var site = {
        id: 0,
        name: this.$refs.site_name.value,
        address: {
          id: 0,
          address1: this.$refs.site_address1.value,
          address2: this.$refs.site_address2.value,
          address3: this.$refs.site_address3.value,
          city: this.$refs.site_city.value,
          state: this.$refs.site_state.value,
          postcode: this.$refs.site_postcode.value,
        },
        contact: this.$refs.site_contact.value,
        phone: this.$refs.site_phone.value,
        notes: this.$refs.site_notes.value,
        customer_id: this.customer_id,
        active: true,
      };
      this.apiCreateSite(site);
      this.$emit("close");
    },
    _reload() {
      if (this.name == "" && this.customers && this.customer_id) {
        var index = this.customers.findIndex(v => v.id == this.customer_id);
        if (index > -1) {
          this.name = this.customers[index].name;
        }
      }
    },
    clear() {
      this.name = "";
      if (this.customers && this.customer_id) {
        var index = this.customers.findIndex(v => v.id == this.customer_id);
        if (index > -1) {
          this.name = this.customers[index].name;
        }
      }
    },
  },
  components: {},
};
</script>
